import { render, staticRenderFns } from "./UserNotificationsContainer.vue?vue&type=template&id=f041d2dc&"
import script from "./UserNotificationsContainer.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports